import React from 'react';

import styles from './styles.sass';

import { GOOGLE_DESIGN_URLS, FAST_COMPANY_URLS } from '../../constants';
import { getImgSrcSet } from '../../../../utils';

const Press = () => (
  <div className={styles.pressSectionContent}>
    <div className={styles.appOfTheDay}>
      <p className={styles.pressQuote}>
        {`"`}App of the Day{`"`}
      </p>
      <p className={styles.pressStore}>APPLE APP STORE</p>
    </div>
    <div className={styles.googlePlay}>
      <div className={styles.pressBadgeWrapper}>
        <svg
          viewBox="0 0 151 30"
          xmlns="http://www.w3.org/2000/svg"
          focusable="false"
          aria-hidden="true"
        >
          <g
            id="Home-Page"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Anchor-HP---desktop---dark-v1"
              transform="translate(-963.000000, -3829.000000)"
              fill="#292F36"
            >
              <g
                id="TESTIMONIALS"
                transform="translate(115.000000, 3814.000000)"
              >
                <g
                  id="Google-testimonia"
                  transform="translate(790.000000, 15.000000)"
                >
                  <g
                    id="editors-choice-badge"
                    transform="translate(58.500000, 0.000000)"
                  >
                    <path
                      d="M80.7105811,21.6486902 L75.4631396,18.8873031 L70.2156982,21.7241379 L71.2507372,15.7486773 L67,11.5115325 L72.8386817,10.6423746 L75.4778838,5.17241379 L78.0875976,10.5669269 L84,11.4753176 L79.7124024,15.7094445 L80.7105811,21.6486902 Z M85.3622293,0 L65.6377707,0 C64.186359,0 63,1.18887733 63,2.64021564 L63,22.3815379 C63,23.1277783 63.3146615,23.8016646 63.8164191,24.2840253 C63.9935934,24.4911567 64.2586461,24.7068003 64.6611861,24.9096756 C66.1622066,25.6672657 72.5759156,28.8778019 73.6786484,29.4098175 C74.7813811,29.941833 75.0294251,30 75.5992176,30 C76.1690101,30 76.6452546,29.7701693 77.2731602,29.4665658 C77.8996485,29.1629623 84.6138451,25.7736688 85.868239,25.1834862 C86.4848055,24.8940698 86.9497109,24.5989785 87.2657898,24.203159 C87.7193559,23.7293105 88,23.0866358 88,22.3815379 L88,2.64021564 C88,1.18887733 86.8122236,0 85.3622293,0 L85.3622293,0 Z"
                      id="Fill-16"
                    />
                    <polygon
                      id="Fill-18-Copy"
                      transform="translate(26.250000, 15.000000) rotate(90.000000) translate(-26.250000, -15.000000) "
                      points="25.5 41 27 41 27 -11 25.5 -11"
                    />
                    <polygon
                      id="Fill-18-Copy-2"
                      transform="translate(124.250000, 15.000000) rotate(90.000000) translate(-124.250000, -15.000000) "
                      points="123.5 41 125 41 125 -11 123.5 -11"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <p className={styles.pressQuote}>
        {`"`}Best apps of 2018{`"`}
      </p>
      <p className={styles.pressStore}>Google Play</p>
    </div>
    <div className={styles.appStoreRating}>
      <div className={styles.appRatingContainer}>
        <div className={styles.starsWrapper}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 136 20"
            aria-hidden="false"
            focusable="true"
            aria-labelledby="appStoreRatingStars"
          >
            <title id="appStoreRatingStars">Five stars</title>
            <g fill="#292F36" fillRule="evenodd">
              <path d="M11 16.5l-6.47 3.4 1.24-7.2L.54 7.6l7.23-1.05L11 0l3.23 6.55 7.23 1.05-5.23 5.1 1.24 7.2zM40 16.5l-6.47 3.4 1.24-7.2-5.23-5.1 7.23-1.05L40 0l3.23 6.55 7.23 1.05-5.23 5.1 1.24 7.2zM68 16.5l-6.47 3.4 1.24-7.2-5.23-5.1 7.23-1.05L68 0l3.23 6.55 7.23 1.05-5.23 5.1 1.24 7.2zM96 16.5l-6.47 3.4 1.24-7.2-5.23-5.1 7.23-1.05L96 0l3.23 6.55 7.23 1.05-5.23 5.1 1.24 7.2zM125 16.5l-6.47 3.4 1.24-7.2-5.23-5.1 7.23-1.05L125 0l3.23 6.55 7.23 1.05-5.23 5.1 1.24 7.2z" />
            </g>
          </svg>
        </div>
        <p className={styles.pressStore}>AVERAGE RATING ON THE APP STORE</p>
      </div>
    </div>
    <div className={styles.fastCompany}>
      <p className={styles.pressAwardName}>Most Innovative Companies 2018</p>
      <img
        className={styles.pressImage}
        src={FAST_COMPANY_URLS[0]}
        srcSet={getImgSrcSet(FAST_COMPANY_URLS)}
        alt="FastCompany logo"
      />
    </div>
    <div className={styles.adAgeContainer}>
      <p className={styles.pressAwardName}>
        AdAge Agency A-List Creativity Award
      </p>
      <p className={styles.adAgeTitle}>Anchor Sponsorships</p>
      <p className={styles.pressYear}>2019 Marketing Product of the Year</p>
    </div>
    <div className={styles.googleDesign}>
      <p className={styles.pressAwardName}>Material Design Award</p>
      <img
        className={styles.pressImage}
        src={GOOGLE_DESIGN_URLS[0]}
        srcSet={getImgSrcSet(GOOGLE_DESIGN_URLS)}
        alt="Google Design logo"
      />
    </div>
  </div>
);

export { Press };
